import React from 'react';
import {
    Box,
    Typography,
    Avatar,
    IconButton,
    Chip,
    Tooltip
} from '@mui/material';
import {
    CheckCircle as AcceptIcon,
    Cancel as DeclineIcon,
    Send as ReportIcon,
    SportsEsports as GameIcon
} from '@mui/icons-material';

const CompactChallengeCard = ({ 
    challenge, 
    type, 
    onAccept, 
    onDecline, 
    onReportResult 
}) => {
    // Determine opponent based on type
    const opponent = type === 'incoming' 
        ? challenge.challenger 
        : challenge.challenged || challenge.challenger;
    
    const opponentName = opponent?.name || opponent?.username || 'Unknown';
    const opponentInitial = opponentName.charAt(0).toUpperCase();

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                p: 1.5,
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                transition: 'all 0.2s',
                '&:hover': {
                    borderColor: 'primary.main',
                    boxShadow: 1,
                }
            }}
        >
            {/* Opponent Avatar */}
            <Avatar 
                sx={{ 
                    width: 40, 
                    height: 40, 
                    bgcolor: 'primary.main',
                    fontWeight: 600
                }}
            >
                {opponentInitial}
            </Avatar>

            {/* Challenge Info */}
            <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                <Typography 
                    variant="body2" 
                    sx={{ 
                        fontWeight: 600,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}
                >
                    {opponentName}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.25 }}>
                    <GameIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                    <Typography variant="caption" color="text.secondary">
                        {challenge.game_name || 'Game'}
                    </Typography>
                </Box>
            </Box>

            {/* Challenge Type Badge */}
            {challenge.challenge_type === 'team' && (
                <Chip 
                    label="Team" 
                    size="small" 
                    color="secondary"
                    sx={{ height: 20, fontSize: '0.7rem' }}
                />
            )}

            {/* Action Buttons */}
            {type === 'incoming' && (
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                    <Tooltip title="Accept Challenge">
                        <IconButton 
                            size="small" 
                            color="success"
                            onClick={onAccept}
                            sx={{ 
                                bgcolor: 'success.light',
                                '&:hover': { bgcolor: 'success.main' }
                            }}
                        >
                            <AcceptIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Decline Challenge">
                        <IconButton 
                            size="small" 
                            color="error"
                            onClick={onDecline}
                            sx={{ 
                                bgcolor: 'error.light',
                                '&:hover': { bgcolor: 'error.main' }
                            }}
                        >
                            <DeclineIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Box>
            )}

            {type === 'accepted' && (
                <Tooltip title="Report Result">
                    <IconButton 
                        size="small" 
                        color="success"
                        onClick={onReportResult}
                        sx={{ 
                            bgcolor: 'success.light',
                            '&:hover': { bgcolor: 'success.main' }
                        }}
                    >
                        <ReportIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            )}
        </Box>
    );
};

export default CompactChallengeCard;

